export const bronnen = {
  "type": "FeatureCollection",
  "name": "Bronnen",
  "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  "features": [
    { "type": "Feature", "properties": { "Type": "WKO" }, "geometry": { "type": "Point", "coordinates": [ 5.58354, 52.024462 ] } },
    { "type": "Feature", "properties": { "Type": "RWZI" }, "geometry": { "type": "Point", "coordinates": [ 5.52127, 52.0381 ] } }
  ]
}
  